import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import AppConfig from "../../../AppConfig";
import {
    ActivityIndicator,
    CCText,
    TouchableWithoutFeedback,
    View
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import {DarkButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import QRCode from "qrcode.react";
import {IsPWA} from "../../../custom-packages/pwa-helper/pwa-helper";
import Styles from "../../../Styles";
import ActivityIndicatorWrapper from "../../../components/public/UI/ActivityIndicatorWrapper";

const TMarketingSettingsScreen = {
    enUS: {
        'UNSUBSCRIBED': 'Unsubscribed Successfully',
    },
    esMX: {
        'UNSUBSCRIBED': 'Suscripción de correos cancelada exitosamente',
    },
};

const MarketingSettingsScreen = () => {
    const params = useParams()
    const Auth = useSelector((state) => state.Auth);
    const [loading, setLoading] = useState(true);

    const id = params.id;

    useEffect(() => {
        const f = async () => {
            const response = await fetch(AppConfig.URL + '/Account/UpdateMarketingSettings/' + id + '?subscribed=false', {
                method: 'GET',
                headers: {
                    'Authorization': Auth.token,
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            setLoading(false)
        }

        f()
    }, []);

    if(loading) {
        return <ActivityIndicatorWrapper />;
    }


    return (
        <div style={{ marginTop: 50, fontSize: 22, textAlign: 'center' }}>
            {TMarketingSettingsScreen[AppConfig.lang].UNSUBSCRIBED}
        </div>
    );
};


export default MarketingSettingsScreen;